<template>
  <div class="home">
    <Navbar :is-active="6"></Navbar>
    <div class="body">
      <MesasSidebar active="menu" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Menú</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Nombre del producto" v-model="menu_name" @keyup="search" />
          <select v-model="menu_status" @change="search">
            <option value="">Estado</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>
        </div>
        <div class="page__buttons">
          <button @click="createItem()" class="button">
            Nuevo producto <i class="fas fa-plus"></i>
          </button>
          <ButtonExport
            :data="items_export"
            :columns="columns"
            :sheet-name="'Menú Mesas'"
            :file-name="'Reporte Menu Mesas'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="({ label }, index) of columns" :key="index">{{ label }}</p>
            <p>Acción</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="item of items" :key="item.id">
              <p>{{ item.menu_name }}</p>
              <p>S/ {{ Number(item.menu_price).toFixed(2) }}</p>
              <p>{{ item.menu_status === 1 ? 'Activo' : 'Inactivo' }}</p>
              <p>{{ dateFormat(item.created_at) }}</p>
              <div class="dropdown">
                <button class="button" @click="show('id-dropdown-content'+item.id)">
                  <i class="fa fa-ellipsis" style="color: red"></i>
                </button>
                <div
                  @mouseleave="show('id-dropdown-content'+item.id)"
                  class="dropdown-content"
                  :id="'id-dropdown-content'+item.id"
                >
                  <router-link :to="{ path: '/Client/showmenumesas', query: { id: item.id }}" class="dropdown-item">
                    <i class="far fa-eye"></i> Ver Detalle
                  </router-link>
                  <button class="dropdown-item" @click="deleteItem(item.id)">
                    <i class="fas fa-trash"></i> Eliminar
                  </button>
                  <div class="dropdown-item-special">
                    Activado
                    <input
                      :id="'check_'+item.id"
                      type="checkbox"
                      :checked="(item.menu_status === 1)"
                      class="dropdown-checkbox"
                      @change="activateItem($event, item.id)"
                    />
                    <label class="wrapper" :for="'check_'+item.id">
                      <span class="circle"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination :data="pagination" v-on:changePage="handleClickInParent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import { dateFormat } from '@/utils/formats'
import ButtonExport from '@/components/ButtonExport.vue'
import Pagination from '@/components/Pagination.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import $ from 'jquery'

export default {
  name: 'MenuMesas',
  components: {
    Navbar,
    MesasSidebar,
    ButtonExport,
    Pagination,
    OpenArrow
  },
  data() {
    return {
      items: [],
      items_export: [],
      pagination: [],
      empty: false,
      timeout: null,
      menu_name: '',
      menu_status: '',
      columns: [
        { label: 'Nombre', field: 'menu_name' },
        { label: 'Precio', field: 'menu_price' },
        { label: 'Estado', field: 'menu_status' },
        { label: 'Fecha Registro', field: 'created_at', dataFormat: this.dateFormat }
      ]
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.getall()
  },
  methods: {
    dateFormat,
    show(divID) {
      if (!$('body').hasClass('cerrarModal')) {
        $('#' + divID).fadeIn()
        setTimeout(function () {
          $('body').addClass('cerrarModal')
        }, 10)
      }
    },
    handleClickInParent(page) {
      this.getall(page)
    },
    clean_filter() {
      this.menu_name = ''
      this.menu_status = ''
      this.getall()
    },
    search() {
      clearTimeout(this.timeout)
      const self = this
      this.timeout = setTimeout(function () {
        self.getall(1)
      }, 500)
    },
    async getall(page = 1) {
      try {
        const res = await axios.get('general/menu-product', {
          params: {
            page: page,
            menu_company_id: localStorage.getItem('company_id'),
            menu_name: this.menu_name || null,
            menu_status: this.menu_status || null
          }
        })
        if (res.data.data && res.data.data.total > 0) {
          this.items = res.data.data.data
          this.pagination = res.data.data
          this.items_export = res.data.export
          this.empty = false
        } else {
          this.items = []
          this.pagination = {}
          this.items_export = []
          this.empty = true
        }
      } catch (e) {
        this.items = []
        this.pagination = {}
        this.items_export = []
        this.empty = true
      }
    },
    createItem() {
      this.$router.push('/Client/addmenumesas')
    },
    activateItem(e, id) {
      axios.put('general/menu-product/' + id, {
        menu_status: e.target.checked ? 1 : 0
      }).then(() => {
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: e.target.checked ? 'Activado correctamente' : 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      })
    },
    async deleteItem(id) {
      const result = await this.$swal({
        title: '¿Deseas eliminar el producto del menú?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#ff3128',
        confirmButtonColor: '#32ba7c'
      })

      if (result.isConfirmed) {
        await axios.delete('general/menu-product/' + id)
        this.getall()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: 'Eliminado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  display: flex;
}

.body__containt {
  min-height: 87vh;
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
  margin: 0;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters input,
.body__containt .page__filters select {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 10px 16px;
  height: 2.75rem;
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: #32ba7c;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  overflow: visible;
  padding-bottom: 220px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-headers p {
  width: calc(100% / 5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  margin: 0;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
  overflow: visible;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  height: 60px;
  border-radius: 15px;
  display: flex;
  transition: 0.3s ease;
  overflow: visible;
  position: relative;
}

.body__containt .page__table .table-body .data:hover {
  background: #ffeeed;
}

.body__containt .page__table .table-body .data p {
  width: calc(100% / 5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding: 0 0.5rem;
}

.body__containt .page__table .table-body .data .dropdown {
  width: calc(100% / 5);
  position: relative;
  overflow: visible;
  z-index: 1;
}

.body__containt .page__table .table-body .data .dropdown:hover {
  z-index: 20;
}

.dropdown-content {
  top: calc(100% + 4px);
  right: 0;
  left: auto;
  margin-top: 0;
  margin-right: 0;
  z-index: 1000;
  padding: 8px 0;
}

.dropdown-item {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>
